import baseUrl from '../baseUrl'
export default {
	wx: baseUrl + '/v1/wx',
	sdk: baseUrl + '/v1/wx/sdk',
	uploginLog: baseUrl + '/v1/login/login-log',
	appid: baseUrl + '/v1/wx/appid',
	refreshToken: baseUrl + '/v1/wx/refresh-token',
	getUserInfo: baseUrl + '/v1/common/user-info',
	device: baseUrl + '/v1/common/device',
	deviceNumber: baseUrl + '/v1/device/get-pay-device',
	unbind: baseUrl + '/v1/common/unbind',
	upMobile: baseUrl + '/v1/common/up-mobile',

	sendCode: baseUrl + '/v1/site/sms-code',
	register: baseUrl + '/v1/register/register',
	regSta: baseUrl + '/v1/register/reg-sta',
	getRoleCode: baseUrl + '/v1/login/before-login',
	checkDst: baseUrl + '/v1/login/check-dst',
	checkLogin: baseUrl + '/v1/login/check-login',
	
	getShareLine: baseUrl + '/v1/member-line/share-line',
    saveShareLine: baseUrl + '/v1/member-line/acc-line',
    saveShareLine: baseUrl + '/v1/member-line/acc-line',

    getDeviceRole: baseUrl + '/v1/device/role',
    getWifiText: baseUrl + '/v1/common/wifi-text',
    BindUser: baseUrl + '/v1/common/bind-user',
}
